<template>
  <div class="relative group sm:w-60 flex-shrink-0">
    <GraduationCap
      class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 w-4 h-4 group-focus-within:text-blue-600 transition-colors"
    />
    <select
      v-model="selectedClassId"
      @change="handleClassChange"
      class="w-full pl-10 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-200 focus:border-blue-500 focus:outline-none transition-all duration-200 bg-white text-gray-800 appearance-none disabled:opacity-50 disabled:cursor-not-allowed text-sm sm:text-base shadow-sm hover:border-gray-400"
    >
      <option value="">All Classes</option>
      <option
        v-for="cls in classes"
        :key="cls._id"
        :value="cls._id"
        class="truncate"
        :title="`${cls.name}${cls.section ? ` - ${cls.section}` : ''}`"
      >
        {{ cls.name }}{{ cls.section ? ` - ${cls.section}` : "" }}
      </option>
    </select>
    <ChevronDown
      class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 w-4 h-4 pointer-events-none"
    />
  </div>
</template>

<script setup>
  import { ref, onMounted, computed, watch } from "vue";
  import { useStore } from "vuex";
  import { useRoute } from "vue-router";
  import { GraduationCap, ChevronDown } from "lucide-vue-next";

  const store = useStore();
  const route = useRoute();

  const selectedClassId = ref("");
  const classes = computed(() => store.getters.allClasses || []);

  const emit = defineEmits(["selected-class"]);

  onMounted(async () => {
    // Fetch all classes first
    await store.dispatch("fetchAllClasses");

    // If query param exists, set it as selected
    if (route.query.classId) {
      selectedClassId.value = route.query.classId;
    }

    // Emit the selected class (initial load)
    handleClassChange();
  });

  // Emit full class object when dropdown changes
  function handleClassChange() {
    const cls =
      classes.value.find((c) => c._id === selectedClassId.value) || null;
    emit("selected-class", cls); // ✅ emit full class object
  }

  watch(selectedClassId, () => {
    handleClassChange();
  });
</script>
